// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ga4G","clinicsSelect":"styles_clinicsSelect__3k1_r"};